import { Layout } from 'components/index';
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { DashboardTabState } from 'types/enums/DashboardTabState';
import ToDoTab from './DashboardTabs/ToDoDashboard/ToDoTabScreen';
import KpiMetricsTab from './DashboardTabs/KpiMetricsTab';
import DashboardTabs from './DashboardTabs/DashboardTabs';
import TabContext from '@mui/lab/TabContext/TabContext';
import { useAppState } from 'store/Provider';
import TabPanel from '@mui/lab/TabPanel';
import moment from 'moment';

const startDate = moment().subtract(1, 'year').startOf('month').format('YYYY-MM-DD');
const endDate = moment().endOf('month').format('YYYY-MM-DD');

type Metric = { id: number; page_title: string };

const DashboardPage: React.FC<RouteComponentProps> = ({ match }) => {
  const { state } = useAppState();
  const [pendingStartDate, setPendingStartDate] = React.useState<string>(startDate);
  const [pendingEndDate, setPendingEndDate] = React.useState<string>(endDate);
  const metricPage = [
    { id: 1, page_title: 'Workflow' },
    { id: 2, page_title: 'Acceptance' },
    { id: 3, page_title: 'Performance' },
    { id: 4, page_title: 'Cover Ratio' },
    { id: 5, page_title: 'Financial Kpi' },
  ] as const;
  const [metric, setMetric] = React.useState<Metric>(metricPage[0]);

  return (
    <Layout name="Dashboard" path="" isWelcome>
      <TabContext value={state.dashboard.pageHandler.parentTab}>
        <DashboardTabs currentToAssignCount={0} />
        <TabPanel sx={{ p: 1 }} value={DashboardTabState.TODO}>
          <ToDoTab />
        </TabPanel>
        <TabPanel sx={{ p: 1 }} value={DashboardTabState.KPI_METRICS}>
          <KpiMetricsTab
            pendingStartDate={pendingStartDate}
            pendingEndDate={pendingEndDate}
            setPendingStartDate={setPendingStartDate}
            setPendingEndDate={setPendingEndDate}
            metric={metric}
            setMetric={setMetric}
            metricPage={metricPage}
          />
        </TabPanel>
      </TabContext>
    </Layout>
  );
};

export default DashboardPage;
